import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-detail_btn_copy",
  "use": "icon-detail_btn_copy-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol viewBox=\"0 0 12 12\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-detail_btn_copy\"><clipPath id=\"icon-detail_btn_copy_a\"><path d=\"m0 0h12v12h-12z\" /></clipPath><g clip-path=\"url(#icon-detail_btn_copy_a)\" fill=\"#1a1a1a\"><path d=\"m7.5 9h-5c-.8 0-1.5-.7-1.5-1.5v-5c0-.8.7-1.5 1.5-1.5h5c.8 0 1.5.7 1.5 1.5v5c0 .8-.7 1.5-1.5 1.5zm-5-7c-.3 0-.5.2-.5.5v5c0 .3.2.5.5.5h5c.3 0 .5-.2.5-.5v-5c0-.3-.2-.5-.5-.5z\" /><path d=\"m9.5 11h-5c-.8 0-1.5-.7-1.5-1.5v-.5c0-.3.2-.5.5-.5s.5.2.5.5v.5c0 .3.2.5.5.5h5c.3 0 .5-.2.5-.5v-5c0-.3-.2-.5-.5-.5h-.5c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h.5c.8 0 1.5.7 1.5 1.5v5c0 .8-.7 1.5-1.5 1.5z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/detail_btn_copy.svg
// module id = Tb0/
// module chunks = 87